import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=a1941e58&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=a1941e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1941e58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1941e58')) {
      api.createRecord('a1941e58', component.options)
    } else {
      api.reload('a1941e58', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=a1941e58&scoped=true&", function () {
      api.rerender('a1941e58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k9cxPCNEdpbi/JS/teamMember.vue"
export default component.exports